import React from "react";
import InternalLink from "./InternalLink";

import "./ReadMoreWrapper.css";

type Props = {
  href: string;
  lexicon: {
    readMore: string;
  };
  html: string;
  messageTitle: string;
};

export default function ReadMoreWrapper({
  href,
  lexicon,
  html,
  messageTitle,
}: Props) {
  const truncated = html.slice(0, 350) + "...";
  return (
    <div className="ReadMoreWrapper">
      <article
        className="max-w-lg mx-auto"
        dangerouslySetInnerHTML={{ __html: truncated }}
      ></article>
      <InternalLink
        href={href}
        className="ReadMoreWrapper__link"
        aria-label={`${lexicon.readMore}: ${messageTitle}`}
      >
        {lexicon.readMore}
      </InternalLink>
    </div>
  );
}
